import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/core/services/user/user.service';
import {
  AdminEventAccepted,
  AdminEventCreate,
  AdminSummary,
  AdminUser
} from '../interfaces/admin.interfaces';

@Injectable({
  providedIn: 'root'
})
export class AdminApiService {
  readonly #http = inject(HttpClient);
  readonly #userService = inject(UserService);
  readonly #baseUrl = `${environment.url}/admin`;

  public getMe(): Observable<AdminUser> {
    return this.#http.get<AdminUser>(`${this.#baseUrl}/me`, {
      headers: this.#adminHeaders()
    });
  }

  public getSummary(): Observable<AdminSummary> {
    return this.#http.get<AdminSummary>(`${this.#baseUrl}/analytics/summary`, {
      headers: this.#adminHeaders()
    });
  }

  public recordEvent(event: AdminEventCreate): Observable<AdminEventAccepted> {
    return this.#http.post<AdminEventAccepted>(
      `${this.#baseUrl}/events`,
      event,
      {
        headers: this.#adminHeaders()
      }
    );
  }

  #adminHeaders(): HttpHeaders {
    const employeeId = this.#userService.getEmployeeId();
    return new HttpHeaders({
      'X-Employee-Id': employeeId,
      'X-Admin-User': employeeId
    });
  }
}
